var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTick = function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1L3.5 6.5L1 4",
    stroke: "#2298DA",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgTick;